import { ORDER_METHODS } from '../../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.ROOM_SERVICE]: 'Vor Ort',
  },
  feedback: {
    payment_method_disabled: 'Wir akzeptieren keine {{paymentMethod}} für {{orderMethod}} Bestellungen',
  },
};
